import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateExternalCardAddress = gql`
  mutation UpdateExternalCardAddress($input: UpdateExternalCardAddressInput!) {
    updateExternalCardAddress(input: $input) {
      ... on UpdateExternalCardAddressResultSuccess {
        success
        __typename
      }

      ... on UpdateExternalCardAddressResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
`;
